import { Injectable, computed, signal } from '@angular/core';
import { environment } from '../../environments/environment';

type ProviderKey = 'emailPassword' | 'google' | 'facebook' | 'apple';

export type AuthProviderToggles = Record<ProviderKey, boolean>;

declare global {
  interface Window {
    RESTOMATOR_AUTH_PROVIDERS?: Partial<AuthProviderToggles>;
    RESTOMATOR_AUTH_REDIRECT_HOSTS?: string[];
  }
}

@Injectable({ providedIn: 'root' })
export class AuthConfigurationService {
  private readonly baseToggle = signal<AuthProviderToggles>({
    emailPassword: environment.authProviders.emailPassword,
    google: environment.authProviders.google,
    facebook: environment.authProviders.facebook,
    apple: environment.authProviders.apple
  });

  private readonly runtimeToggle = signal<Partial<AuthProviderToggles>>(
    typeof window !== 'undefined' && window.RESTOMATOR_AUTH_PROVIDERS
      ? window.RESTOMATOR_AUTH_PROVIDERS
      : {}
  );

  readonly providerToggles = computed<AuthProviderToggles>(() => ({
    emailPassword: this.runtimeToggle().emailPassword ?? this.baseToggle().emailPassword,
    google: this.runtimeToggle().google ?? this.baseToggle().google,
    facebook: this.runtimeToggle().facebook ?? this.baseToggle().facebook,
    apple: this.runtimeToggle().apple ?? this.baseToggle().apple
  }));

  readonly allowHttpOnLocalhost = environment.redirect.allowHttpOnLocalhost;

  readonly allowedRedirectHosts = computed(() => {
    const baseHosts = new Set(environment.redirect.allowedHosts ?? []);
    const runtimeHosts = typeof window !== 'undefined' && Array.isArray(window.RESTOMATOR_AUTH_REDIRECT_HOSTS)
      ? window.RESTOMATOR_AUTH_REDIRECT_HOSTS
      : [];
    runtimeHosts.forEach((host) => baseHosts.add(host));
    return Array.from(baseHosts);
  });
}
